export default defineAppConfig({
  ui: {
    primary: 'indigo',
    gray: 'neutral',
    button: {
      default: {
        color: 'orange'
      }
    },
    checkbox: {
      default: {
        color: 'orange'
      }
    },
    dropdown: {
      width: 'w-auto'
    },
    
    variables: {
      light: {
        background: '#f7f7f7'
      },
      dark: {
        background: '#181818'
      },
      header: {
        height: '4rem'
      }
    },
    avatar: {
      size: {
        '4xl': 'h-40 w-40 text-[6rem]'
      }
    },
    pagination: {
      wrapper: 'gap-2',
      rounded: 'rounded rounded-2',
      
    },
    badge: {
      color: {
        primary: {
          solid: 'ring-0 text-white dark:text-white bg-[#4c3f87] dark:bg-[#4c3f87]'
        },
        green: {
          solid: 'ring-0 text-white dark:text-white bg-green-800 dark:bg-green-800'
        },
        slate: {
          solid: 'ring-0 text-black dark:text-black bg-slate-400 dark:bg-slate-400'
        },
      },
      variant: {
        solid: 'text-white dark:text-gray-900',
      }
    },
    card: {
      base: 'border-0',
      background: 'bg-white dark:bg-gray-800',
      rounded: 'rounded-lg',
      shadow: ' shadow-1',
      body: {
        base: '',
        background: '',
        padding: 'py-1 sm:p-1 '
      },
      header: {
        base: '',
        padding: 'px-3 py-1 sm:px-3'
      },
      footer: {
        base: '',
        padding: 'px-3 py-1 sm:px-3'
      }
    },
    input: {
      placeholder: 'text-gray-400',
      color: {
        white: {
          outline: 'shadow-sm bg-white dark:bg-gray-900 text-gray-900 dark:text-white ring-1 ring-inset ring-gray-300 dark:ring-gray-700 focus:ring-2 focus:ring-primary-900 dark:focus:ring-primary-400'
        },
      },
    },
    textarea: {
      color: {
        white: {
          outline: 'shadow-sm bg-white dark:bg-gray-900 text-gray-900 dark:text-white ring-1 ring-inset ring-gray-300 dark:ring-gray-700 focus:ring-2 focus:ring-primary-900 dark:focus:ring-primary-400'
        },
      },
    },
    modal: {
      container: 'items-center'
    },
    formGroup: {
      label: {
        base: "lg:block hidden"
      }
    },
    select: {
      placeholder: 'text-gray-500',
      color: {
        white: {
          outline: 'shadow-sm bg-white dark:bg-gray-900 text-gray-900 dark:text-white ring-1 ring-inset ring-gray-300 dark:ring-gray-700 focus:ring-2 focus:ring-primary-900 dark:focus:ring-primary-400'
        },
      },
    },
    radiogroup: {
      wrapper: 'aaaaaa'
    },
    slideover: {
      wrapper: 'w-80 z-40',
      translate: {
        right: '-translate-x-full rtl:translate-x-full',
        left: 'translate-x-full rtl:-translate-x-full',    
      }
    },
    carousel: {
      indicators: {
        wrapper: 'list-indicators'
      }
    }
  }
})